import React, { useEffect, useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import '../../styles/Training.css';

const TrainingDetail = () => {
    const { programType } = useParams();
    const location = useLocation();
    const sectionRefs = useRef({});

    // Interns data organized by program type
    const internsData = {
        "ui-ux-design": {
            total: 3,
            breakdown: [
                { role: "UI/UX Design Intern", count: 3 }
            ]
        },
        "full-stack-development": {
            total: 35,
            breakdown: [
                { role: "Full Stack Intern", count: 35 }
            ]
        },
        "frontend-development": {
            total: 8,
            breakdown: [
                { role: "Mini Project Intern", count: 8 }
            ]
        },
        "backend-development": {
            total: 0,
            breakdown: []
        },
        "digital-marketing": {
            total: 1,
            breakdown: [
                { role: "Digital Marketing Intern", count: 1 }
            ]
        },
        "graphic-designing": {
            total: 1,
            breakdown: [
                { role: "Graphic Designing Intern", count: 1 }
            ]
        },
        "human-resources": {
            total: 2,
            breakdown: [
                { role: "Human Resources Intern", count: 2 }
            ]
        }
    };

    const allTrainingData = {
        "ui-ux-design": {
            "title": "UI/UX Design Training",
            "icon": "🎨",
            "color": "#8b5cf6",
            "duration": "6 Weeks",
            "level": "Beginner to Advanced",
            "description": "Master user interface and experience design",
            "overview": "Comprehensive UI/UX design course covering principles, tools, and practical implementation. Perfect for beginners and professionals looking to enhance their skills.",
            "curriculum": [
                {
                    "id": "fundamentals",
                    "week": "Week 1-2",
                    "title": "Design Fundamentals",
                    "topics": [
                        "Design Principles & Psychology",
                        "Color Theory & Typography",
                        "Layout & Composition",
                        "Design Systems",
                        "Wireframing & Prototyping"
                    ]
                },
                {
                    "id": "tools",
                    "week": "Week 3-4",
                    "title": "Design Tools Mastery",
                    "topics": [
                        "Figma Complete Guide",
                        "Adobe XD & Sketch",
                        "Prototyping Tools",
                        "Collaboration Platforms",
                        "Design Handoff"
                    ]
                },
                {
                    "id": "research",
                    "week": "Week 5",
                    "title": "User Research",
                    "topics": [
                        "User Research Methods",
                        "Persona Creation",
                        "User Testing",
                        "Analytics & Data",
                        "Competitor Analysis"
                    ]
                },
                {
                    "id": "portfolio",
                    "week": "Week 6",
                    "title": "Portfolio & Career",
                    "topics": [
                        "Case Studies Creation",
                        "Design Projects",
                        "Client Presentation",
                        "Interview Preparation",
                        "Freelancing Basics"
                    ]
                }
            ],
            "features": [
                "Live Interactive Sessions",
                "Project-Based Learning",
                "Mentorship Support",
                "Certificate of Completion",
                "Job Placement Assistance"
            ],
            "instructors": [
                {
                    "name": "Sarah Johnson",
                    "role": "Lead UI/UX Designer",
                    "experience": "8+ years at Google & Facebook"
                },
                {
                    "name": "Mike Chen",
                    "role": "UX Researcher",
                    "experience": "6+ years in EdTech"
                }
            ],
            "pricing": {
                "regular": "₹25,000",
                "earlyBird": "₹20,000",
                "installment": "₹9,000 x 3"
            },
            "nextBatch": "15th January 2024"
        },
        "full-stack-development": {
            "title": "Full Stack Development",
            "icon": "💻",
            "color": "#10b981",
            "duration": "12 Weeks",
            "level": "Intermediate",
            "description": "Complete web development training",
            "overview": "Become a full-stack developer with our intensive program covering frontend, backend, databases, and deployment.",
            "curriculum": [
                {
                    "id": "frontend",
                    "week": "Week 1-4",
                    "title": "Frontend Development",
                    "topics": [
                        "HTML5, CSS3, JavaScript ES6+",
                        "React.js with Hooks",
                        "State Management (Redux)",
                        "Responsive Design",
                        "Web Performance"
                    ]
                },
                {
                    "id": "backend",
                    "week": "Week 5-8",
                    "title": "Backend Development",
                    "topics": [
                        "Node.js & Express",
                        "RESTful API Development",
                        "Authentication & Authorization",
                        "Database Design",
                        "Server Management"
                    ]
                },
                {
                    "id": "database",
                    "week": "Week 9-10",
                    "title": "Database & DevOps",
                    "topics": [
                        "MongoDB & MySQL",
                        "ORM/ODM Concepts",
                        "Git & GitHub",
                        "CI/CD Pipeline",
                        "Deployment Strategies"
                    ]
                },
                {
                    "id": "projects",
                    "week": "Week 11-12",
                    "title": "Projects & Career",
                    "topics": [
                        "Capstone Project",
                        "Code Reviews",
                        "Best Practices",
                        "Interview Preparation",
                        "Resume Building"
                    ]
                }
            ],
            "features": [
                "Live Coding Sessions",
                "Real Projects",
                "Code Reviews",
                "Certificate",
                "Placement Support"
            ],
            "instructors": [
                {
                    "name": "Alex Thompson",
                    "role": "Senior Full Stack Developer",
                    "experience": "10+ years in MNCs"
                }
            ],
            "pricing": {
                "regular": "₹45,000",
                "earlyBird": "₹38,000",
                "installment": "₹15,000 x 3"
            },
            "nextBatch": "20th January 2024"
        },
        "frontend-development": {
            "title": "Frontend Development",
            "icon": "🖥️",
            "color": "#3b82f6",
            "duration": "8 Weeks",
            "level": "Beginner",
            "description": "Modern frontend development skills",
            "overview": "Master frontend development with HTML, CSS, JavaScript, and modern frameworks like React. Build responsive, interactive web applications.",
            "curriculum": [
                {
                    "id": "basics",
                    "week": "Week 1-2",
                    "title": "Web Fundamentals",
                    "topics": [
                        "HTML5 Semantic Elements",
                        "CSS3 & Flexbox/Grid",
                        "JavaScript Basics",
                        "DOM Manipulation",
                        "Responsive Design"
                    ]
                },
                {
                    "id": "javascript",
                    "week": "Week 3-4",
                    "title": "Advanced JavaScript",
                    "topics": [
                        "ES6+ Features",
                        "Async Programming",
                        "API Integration",
                        "Error Handling",
                        "Debugging"
                    ]
                },
                {
                    "id": "react",
                    "week": "Week 5-6",
                    "title": "React Framework",
                    "topics": [
                        "React Components",
                        "State & Props",
                        "Hooks & Context",
                        "React Router",
                        "State Management"
                    ]
                },
                {
                    "id": "advanced",
                    "week": "Week 7-8",
                    "title": "Advanced Topics",
                    "topics": [
                        "Performance Optimization",
                        "Testing (Jest)",
                        "TypeScript Basics",
                        "Build Tools",
                        "Portfolio Project"
                    ]
                }
            ],
            "features": [
                "Hands-on Coding",
                "Weekly Projects",
                "Code Reviews",
                "Career Guidance",
                "Certificate"
            ],
            "instructors": [
                {
                    "name": "Priya Sharma",
                    "role": "Frontend Lead",
                    "experience": "7+ years in Product Companies"
                }
            ],
            "pricing": {
                "regular": "₹30,000",
                "earlyBird": "₹25,000",
                "installment": "₹11,000 x 3"
            },
            "nextBatch": "25th January 2024"
        },
        "backend-development": {
            "title": "Backend Development",
            "icon": "⚙️",
            "color": "#f59e0b",
            "duration": "10 Weeks",
            "level": "Intermediate",
            "description": "Server-side development training",
            "overview": "Learn to build robust backend systems with Node.js, databases, and APIs. Focus on security, performance, and scalability.",
            "curriculum": [
                {
                    "id": "nodejs",
                    "week": "Week 1-3",
                    "title": "Node.js Fundamentals",
                    "topics": [
                        "Node.js Basics",
                        "NPM & Modules",
                        "File System Operations",
                        "Event Loop",
                        "Streams & Buffers"
                    ]
                },
                {
                    "id": "express",
                    "week": "Week 4-5",
                    "title": "Express Framework",
                    "topics": [
                        "Routing & Middleware",
                        "Request/Response Handling",
                        "Error Handling",
                        "Authentication",
                        "Security Best Practices"
                    ]
                },
                {
                    "id": "database",
                    "week": "Week 6-7",
                    "title": "Database Management",
                    "topics": [
                        "MongoDB & Mongoose",
                        "MySQL & Sequelize",
                        "Database Design",
                        "ORM/ODM Concepts",
                        "Query Optimization"
                    ]
                },
                {
                    "id": "api-devops",
                    "week": "Week 8-10",
                    "title": "API & DevOps",
                    "topics": [
                        "RESTful API Design",
                        "GraphQL Basics",
                        "Testing (Jest, Supertest)",
                        "Docker Basics",
                        "Deployment & Monitoring"
                    ]
                }
            ],
            "features": [
                "Project-Based Learning",
                "Code Reviews",
                "Industry Best Practices",
                "Certificate",
                "Placement Support"
            ],
            "instructors": [
                {
                    "name": "Rajesh Kumar",
                    "role": "Backend Architect",
                    "experience": "9+ years in FinTech"
                }
            ],
            "pricing": {
                "regular": "₹35,000",
                "earlyBird": "₹30,000",
                "installment": "₹12,000 x 3"
            },
            "nextBatch": "30th January 2024"
        },
        "digital-marketing": {
            "title": "Digital Marketing",
            "icon": "📈",
            "color": "#ec4899",
            "duration": "6 Weeks",
            "level": "Beginner",
            "description": "Comprehensive digital marketing training",
            "overview": "Learn complete digital marketing strategies including SEO, social media, content marketing, and analytics to drive business growth.",
            "curriculum": [
                {
                    "id": "seo",
                    "week": "Week 1-2",
                    "title": "SEO Mastery",
                    "topics": [
                        "Keyword Research",
                        "On-page Optimization",
                        "Technical SEO",
                        "Local SEO",
                        "SEO Analytics"
                    ]
                },
                {
                    "id": "social-media",
                    "week": "Week 3",
                    "title": "Social Media Marketing",
                    "topics": [
                        "Content Strategy",
                        "Platform Management",
                        "Advertising Campaigns",
                        "Analytics & Reporting",
                        "Community Building"
                    ]
                },
                {
                    "id": "content",
                    "week": "Week 4",
                    "title": "Content Marketing",
                    "topics": [
                        "Blog Writing",
                        "Video Marketing",
                        "Email Marketing",
                        "Content Strategy",
                        "Analytics"
                    ]
                },
                {
                    "id": "paid-ads",
                    "week": "Week 5-6",
                    "title": "Paid Advertising",
                    "topics": [
                        "Google Ads Campaigns",
                        "Facebook/Instagram Ads",
                        "LinkedIn Advertising",
                        "Analytics & ROI",
                        "Conversion Optimization"
                    ]
                }
            ],
            "features": [
                "Live Campaigns",
                "Case Studies",
                "Tools Training",
                "Certificate",
                "Portfolio Building"
            ],
            "instructors": [
                {
                    "name": "Neha Verma",
                    "role": "Digital Marketing Head",
                    "experience": "8+ years in Agency"
                }
            ],
            "pricing": {
                "regular": "₹20,000",
                "earlyBird": "₹16,000",
                "installment": "₹7,000 x 3"
            },
            "nextBatch": "5th February 2024"
        },
        "graphic-designing": {
            "title": "Graphic Designing",
            "icon": "✏️",
            "color": "#6366f6",
            "duration": "8 Weeks",
            "level": "Beginner",
            "description": "Professional graphic design training",
            "overview": "Learn professional graphic design skills including Adobe Creative Suite, logo design, branding, and print/digital media design.",
            "curriculum": [
                {
                    "id": "fundamentals",
                    "week": "Week 1-2",
                    "title": "Design Fundamentals",
                    "topics": [
                        "Design Principles",
                        "Color Theory",
                        "Typography",
                        "Layout & Composition",
                        "Visual Hierarchy"
                    ]
                },
                {
                    "id": "tools",
                    "week": "Week 3-4",
                    "title": "Design Tools",
                    "topics": [
                        "Adobe Photoshop",
                        "Adobe Illustrator",
                        "Adobe InDesign",
                        "Figma",
                        "Canva Pro"
                    ]
                },
                {
                    "id": "specializations",
                    "week": "Week 5-6",
                    "title": "Specializations",
                    "topics": [
                        "Logo & Brand Identity",
                        "Print Design",
                        "UI/UX Basics",
                        "Illustration",
                        "Packaging Design"
                    ]
                },
                {
                    "id": "business",
                    "week": "Week 7-8",
                    "title": "Business Skills",
                    "topics": [
                        "Client Management",
                        "Portfolio Building",
                        "Pricing Strategies",
                        "Freelancing",
                        "Copyright & Legal"
                    ]
                }
            ],
            "features": [
                "Live Design Sessions",
                "Project Work",
                "Portfolio Reviews",
                "Certificate",
                "Freelance Guidance"
            ],
            "instructors": [
                {
                    "name": "Arun Desai",
                    "role": "Creative Director",
                    "experience": "12+ years in Advertising"
                }
            ],
            "pricing": {
                "regular": "₹28,000",
                "earlyBird": "₹23,000",
                "installment": "₹10,000 x 3"
            },
            "nextBatch": "10th February 2024"
        },
        "human-resources": {
            "title": "Human Resources Training",
            "icon": "👥",
            "color": "#06b6d4",
            "duration": "6 Weeks",
            "level": "Beginner to Intermediate",
            "description": "Professional HR skills development",
            "overview": "Learn essential HR functions including recruitment, talent management, employee relations, and HR analytics for modern organizations.",
            "curriculum": [
                {
                    "id": "fundamentals",
                    "week": "Week 1-2",
                    "title": "HR Fundamentals",
                    "topics": [
                        "Introduction to HRM",
                        "Recruitment & Selection",
                        "Employee Onboarding",
                        "Compensation & Benefits",
                        "HR Policies & Procedures"
                    ]
                },
                {
                    "id": "talent",
                    "week": "Week 3-4",
                    "title": "Talent Management",
                    "topics": [
                        "Performance Management",
                        "Training & Development",
                        "Succession Planning",
                        "Employee Engagement",
                        "Retention Strategies"
                    ]
                },
                {
                    "id": "compliance",
                    "week": "Week 5",
                    "title": "HR Compliance & Analytics",
                    "topics": [
                        "Labor Laws & Compliance",
                        "Employee Relations",
                        "HR Metrics & Analytics",
                        "Diversity & Inclusion",
                        "HR Technology"
                    ]
                },
                {
                    "id": "strategic",
                    "week": "Week 6",
                    "title": "Strategic HR & Career",
                    "topics": [
                        "Strategic HR Planning",
                        "Change Management",
                        "HR Business Partnering",
                        "Career Path in HR",
                        "Interview Preparation"
                    ]
                }
            ],
            "features": [
                "Live Case Studies",
                "Industry Experts",
                "Practical Assignments",
                "Certificate",
                "Placement Support"
            ],
            "instructors": [
                {
                    "name": "Rohit Mehta",
                    "role": "HR Director",
                    "experience": "10+ years in Corporate HR"
                }
            ],
            "pricing": {
                "regular": "₹22,000",
                "earlyBird": "₹18,000",
                "installment": "₹8,000 x 3"
            },
            "nextBatch": "15th February 2024"
        }
    };

    useEffect(() => {
        const hash = location.hash.replace('#', '');
        if (hash && sectionRefs.current[hash]) {
            setTimeout(() => {
                sectionRefs.current[hash].scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 100);
        }
    }, [location.hash, programType]);

    const program = allTrainingData[programType];
    const programInterns = internsData[programType] || { total: 0, breakdown: [] };

    if (!program) {
        return (
            <div className="program-not-found">
                <h2>Program Not Found</h2>
                <p>Return to <a href="/training">Training Programs</a></p>
            </div>
        );
    }

    return (
        <div className="training-detail2">
            {/* Header Banner */}
            <div
                className="program-header-banner2"
                style={{ backgroundColor: `${program.color}15` }}
            >
                <div className="program-header-content2">
                    <div className="program-main-info2">
                        {/* <div className="program-icon-large2" style={{ color: program.color }}>
                            {program.icon}
                        </div> */}
                        <div>
                            <h1>{program.title}</h1>
                            <p className="program-tagline2">{program.description}</p>
                        </div>
                    </div>

                    <div className="program-quick-facts2">
                        <div className="fact2">
                            <span className="fact-label2">Duration</span>
                            <span className="fact-value2">{program.duration}</span>
                        </div>
                        <div className="fact2">
                            <span className="fact-label2">Level</span>
                            <span className="fact-value2">{program.level}</span>
                        </div>
                        <div className="fact2">
                            <span className="fact-label2">Next Batch</span>
                            <span className="fact-value2">{program.nextBatch}</span>
                        </div>
                        <div className="fact2">
                            <span className="fact-label2">Interns Enrolled</span>
                            <span className="fact-value2">{programInterns.total}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="program-detail-container2">
                {/* Sidebar */}
                <div className="program-sidebar2">
                    <div className="enrollment-card2">
                        <div className="pricing-display2">
                            <div className="price-regular2">
                                <span className="price-label2">Regular Price</span>
                                <span className="price-amount2">{program.pricing.regular}</span>
                            </div>
                            <div className="price-discount2">
                                <span className="price-label2">Early Bird</span>
                                <span className="price-amount2">{program.pricing.earlyBird}</span>
                            </div>
                            <div className="price-installment2">
                                <span className="price-label2">Installment Plan</span>
                                <span className="price-amount2">{program.pricing.installment}</span>
                            </div>
                        </div>

                        <button
                            className="enroll-button2"
                            style={{ backgroundColor: program.color }}
                        >
                            Enroll Now
                        </button>

                        <div className="instructor-info2">
                            <h4>Instructors</h4>
                            {program.instructors.map((instructor, index) => (
                                <div key={index} className="instructor2">
                                    <div className="instructor-avatar2">
                                        {instructor.name.charAt(0)}
                                    </div>
                                    <div className="instructor-details2">
                                        <strong>{instructor.name}</strong>
                                        <p>{instructor.role}</p>
                                        <small>{instructor.experience}</small>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Main Content */}
                <div className="program-main-content2">
                    {/* Overview */}
                    <section className="program-overview2">
                        <h2>Course Overview</h2>
                        <p>{program.overview}</p>

                        <div className="program-features-grid2">
                            {program.features.map((feature, index) => (
                                <div
                                    key={index}
                                    className="program-feature2"
                                    style={{ borderColor: `${program.color}30` }}
                                >
                                    <div className="feature-check2" style={{ color: program.color }}>
                                        ✓
                                    </div>
                                    <span>{feature}</span>
                                </div>
                            ))}
                        </div>
                    </section>

                    {/* Interns Enrolled Section - NEW */}
                    <section className="interns-section2">
                        <h2>Interns Enrolled</h2>
                        <div className="interns-stats2">
                            <div className="total-interns-card2" style={{ backgroundColor: `${program.color}15` }}>
                                <div className="total-interns-number2" style={{ color: program.color }}>
                                    {programInterns.total}
                                </div>
                                <h3>Total Interns</h3>
                                <p>Enrolled in this program</p>
                            </div>

                            <div className="interns-breakdown2">
                                <h4>Breakdown</h4>
                                {programInterns.breakdown.length > 0 ? (
                                    <div className="breakdown-list2">
                                        {programInterns.breakdown.map((item, index) => (
                                            <div key={index} className="breakdown-item2">
                                                <div className="breakdown-role2">
                                                    <div className="role-bullet2" style={{ backgroundColor: program.color }}></div>
                                                    <span>{item.role}</span>
                                                </div>
                                                <div className="breakdown-count2">
                                                    <span className="count-badge2" style={{ backgroundColor: program.color }}>
                                                        {item.count}
                                                    </span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="no-interns2">
                                        <p>No interns currently enrolled in this program</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </section>

                    {/* Curriculum */}
                    <section className="curriculum-section2">
                        <h2>Curriculum</h2>
                        <div className="curriculum-modules2">
                            {program.curriculum.map((module, index) => (
                                <div
                                    key={index}
                                    id={module.id}
                                    ref={el => sectionRefs.current[module.id] = el}
                                    className="module2"
                                >
                                    <div className="module-header2">
                                        <div className="module-week2">{module.week}</div>
                                        <h3>{module.title}</h3>
                                    </div>

                                    <div className="topics-list2">
                                        {module.topics.map((topic, topicIndex) => (
                                            <div
                                                key={topicIndex}
                                                className="topic-item2"
                                                style={{ borderLeftColor: program.color }}
                                            >
                                                <div className="topic-bullet2" style={{ backgroundColor: program.color }}></div>
                                                <span>{topic}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    {/* Who Should Join */}
                    <section className="audience-section2">
                        <h2>Who Should Join?</h2>
                        <div className="audience-cards2">
                            <div className="audience-card2">
                                <div className="audience-icon2">🎓</div>
                                <h4>Students</h4>
                                <p>Looking to start a career in design/development</p>
                            </div>
                            <div className="audience-card2">
                                <div className="audience-icon2">👨‍💼</div>
                                <h4>Professionals</h4>
                                <p>Wanting to upskill or switch careers</p>
                            </div>
                            <div className="audience-card2">
                                <div className="audience-icon2">👨‍💻</div>
                                <h4>Entrepreneurs</h4>
                                <p>Needing to understand design/tech for their business</p>
                            </div>
                            <div className="audience-card2">
                                <div className="audience-icon2">🎨</div>
                                <h4>Creatives</h4>
                                <p>Looking to add tech skills to their creative toolkit</p>
                            </div>
                        </div>
                    </section>

                    {/* FAQ */}
                    <section className="faq-section2">
                        <h2>Frequently Asked Questions</h2>
                        <div className="faq-list2">
                            <div className="faq-item2">
                                <h4>Do I need prior experience?</h4>
                                <p>{program.level === 'Beginner' ?
                                    'No prior experience needed. We start from basics.' :
                                    'Basic programming/design knowledge recommended.'}
                                </p>
                            </div>
                            <div className="faq-item2">
                                <h4>Will I get a certificate?</h4>
                                <p>Yes, upon successful completion you'll receive a certificate.</p>
                            </div>
                            <div className="faq-item2">
                                <h4>Is placement assistance provided?</h4>
                                <p>Yes, we provide resume building, interview prep, and job referrals.</p>
                            </div>
                            <div className="faq-item2">
                                <h4>What if I miss a class?</h4>
                                <p>All sessions are recorded and available for review.</p>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default TrainingDetail;